import React from 'react';

import {AppButton} from '@/components/Button';
import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import {getDeviceNameByType} from '@/services/device/deviceData';
import {formatString} from '@/utils/stringUtils';
import {twx} from '@/utils/tailwindUtils';

import {getConnectionContent} from '../ConnectionPage/connectionContentService';

const HowToUse = ({className, onOpenQsg, deviceType}) => {
    const {tipsIcon, tipsButton} = getConnectionContent();

    if (!tipsIcon || !tipsButton) {
        return null;
    }

    const deviceName = getDeviceNameByType(deviceType);
    const {title, description} = tipsIcon;
    const {text, alt} = tipsButton;

    return (
        <div className={twx('flex flex-col gap-4 rounded-xl bg-secondary p-4 ml:py-8', className)}>
            <div className='flex items-center gap-2'>
                <RemoteIconV2 icon={tipsIcon} className='h-12 w-12 shrink-0' />
                <div className='flex flex-col text-start'>
                    <h3 className='text-16'>{formatString(title, deviceName)}</h3>
                    <p className='tracking-04'>{formatString(description, deviceName)}</p>
                </div>
            </div>
            <AppButton className='mt-0' secondary light aria-label={alt} onClick={onOpenQsg}>
                {text}
            </AppButton>
        </div>
    );
};

export default HowToUse;
